<template>
  <div>
    <button
      v-bind:class="{'red':buttonStyle ==='red'
      ,'blue':buttonStyle==='blue'
      ,'green':buttonStyle==='green'}"
      @click="clickEvent"
    >
      <slot></slot>
    </button>
  </div>
</template>
<!---------->
<script>
export default {
  props: {
    buttonStyle: String,
    name: String
  },
  methods: {
    clickEvent: function (e) {
      this.$emit('childEvent', e.target.value)
    }
  },
  data () {
    return {}
  }
}
</script>
<!---------->
<style scoped>
.common {
  color: yellowgreen;
}
.red {
  background-color: red;
  color: white;
  border-radius: 10pt;
  width: 10vw;
}
.blue {
  background-color: blue;
  color: aliceblue;
  border-radius: 10pt;
  width: 10vw;
}
.green {
  background-color: green;
  color: aliceblue;
  border-radius: 10pt;
  width: 10vw;
}
</style>
